// ── AdminMobileChrome.jsx — 모바일 상단 바 + pull-to-refresh 인디케이터 ─────────
// 2026-08-25 AdminLayout.jsx 300줄 규칙으로 그대로 추출 (동작 불변).
import React from 'react';
import { X, Menu } from 'lucide-react';
import { cn } from '../../../lib/utils';
import { resolveShortcut } from './shortcutHelpers';
import { useCompanyScope } from './CompanyScopeContext';

// 모바일 고정 상단 바: 햄버거 + 브랜드명 + 사용자 등록 바로가기(최대 5개)
// permCodes: 회사별 일일콜(직원 내 정보) 바로가기 이름 찾기용(2026-10-24 — 통합·회사 메뉴도 막대에 그린다)
export function AdminMobileTopBar({ mobileOpen, setMobileOpen, me, mobileShortcuts, location, navigate, permCodes = null }) {
  const scope = useCompanyScope();
  return (
    <div className="fixed left-0 right-0 top-0 z-[1001] h-[52px] flex items-center justify-between px-3 bg-pine-900 border-b border-pine-800">
      {/* 왼쪽: 햄버거/닫기 버튼 + 브랜드명 */}
      <div className="flex items-center gap-2.5">
        <button
          className="border-none bg-transparent text-slate-400 p-[6px_8px] cursor-pointer rounded-lg leading-none"
          onClick={() => setMobileOpen((v) => !v)}
          aria-label="메뉴"
        >
          {mobileOpen ? <X size={20} /> : <Menu size={20} />}
        </button>
        <span className="text-sm font-extrabold text-slate-100">
          {me?.tenant?.displayName || me?.tenant?.name || me?.company?.name || '관리자'}
        </span>
      </div>
      {/* 오른쪽: 사용자 등록 바로가기만 (최대 5개, DB user_preferences). 0개 시 비어있음 */}
      <div className="flex items-center">
        {mobileShortcuts.map((path) => {
          const m = resolveShortcut(path, { scope, permCodes });
          if (!m) return null; // 메뉴에 없거나 지금 못 여는 주소 — 그리지 않는다
          const Icon = m.Icon;
          const isActive = location.pathname === path;
          return (
            <button
              key={path}
              className={cn(
                'border-none bg-transparent p-[6px_8px] cursor-pointer rounded-lg leading-none transition-colors',
                isActive ? 'text-accent-400' : 'text-slate-400',
              )}
              onClick={() => { setMobileOpen(false); navigate(path); }}
              aria-label={m.label}
              title={m.label}
            >
              <Icon size={18} />
            </button>
          );
        })}
      </div>
    </div>
  );
}

// pull-to-refresh 당김 인디케이터
export function PullRefreshIndicator({ pullDistance, pullRefreshing, isPullReady }) {
  if (!(pullDistance > 0 || pullRefreshing)) return null;
  return (
    <div
      className="fixed left-1/2 -translate-x-1/2 z-[1002] px-3.5 inline-flex items-center justify-center rounded-full border border-pine-800 text-xs font-bold select-none pointer-events-none"
      style={{
        top: 56,
        minWidth: 140,
        height: pullRefreshing ? 30 : Math.max(20, Math.min(34, Math.round(pullDistance * 0.38))),
        // 다크 모드는 차콜(--std-navy-*, 2026-09-28). 라이트는 종전 남색 그대로
        background: pullRefreshing ? 'var(--std-navy-subtle, #1e3a5f)' : 'var(--std-navy-surface, #1e2a40)',
        color:      pullRefreshing ? 'var(--std-accent-text, #60b7f7)' : isPullReady ? '#f59e0b' : 'var(--text-muted)',
        boxShadow:  '0 2px 8px rgba(0,0,0,0.3)',
      }}
    >
      {pullRefreshing ? '새로고침 중...' : isPullReady ? '놓으면 새로고침' : '아래로 당겨 새로고침'}
    </div>
  );
}
